import { render, staticRenderFns } from "./EnableConfirmation.vue?vue&type=template&id=10c1b4fe&"
import script from "./EnableConfirmation.vue?vue&type=script&lang=js&"
export * from "./EnableConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./EnableConfirmation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports